import app from '../authentication/firebaseStart';
import * as firebase from "firebase/app";
import { Timestamp } from "@firebase/firestore";

export class APModel {

    macAddress;

    assetName;

    friendlyName;

    siteName;

}


export  class APService {
  
 
  firestore = app.firestore();
 

  getDBValue(value, toUpperCase = true) {
    //Values should be saved as UPPERCASE in DB.
    if(value == null) {
      return "";
    }
    else {
      //Values should be saved as UPPERCASE in DB if toUpperCase is passed
      return (toUpperCase) ?  value.toUpperCase(): value;
    }
   
  }


  async setSiteInfoUpdated(tenantId, site){
    var timestamp = Date.now();

    var options = {
      mergeFields: [
        "siteInfoUpdated"
        ]
    };
    await this.firestore
            .collection("tenants")  
            .doc(tenantId)
            .collection("SiteLocations").doc(site).set({
              "siteInfoUpdated": timestamp
            }, options);
          
  }


  async setSiteAPSUpdated(tenantId, site){
    var timestamp = Date.now();

    var options = {
      mergeFields: [
        "siteApsUpdated"
        ]
    };

    await this.firestore
            .collection("tenants") 
            .doc(tenantId)
            .collection("SiteLocations").doc(site).set({
              "siteApsUpdated": timestamp
            }, options);
          
  }


  async updateSiteLocation(tenantId, oldSite, newSite){
  
    if(newSite == ""){
      //AP unassigned from site..
      //Update oldsite's siteInfoUpated & APS updated
      if(oldSite != "") {
        //Old site exists
        await this.setSiteInfoUpdated(tenantId, oldSite);
        //await this.setSiteAPSUpdated(tenantId, oldSite);
      }
    }
    else {
      //There is a new value for newSite
      if(oldSite == ""){
        //Old site doesn't exists and AP is assinged for that site
        //AP site changed from "" -> site2.
        //So update only site'2 data
        await this.setSiteInfoUpdated(tenantId, newSite);
        //await this.setSiteAPSUpdated(tenantId, newSite);
      }
      else {
        //Old site exists. So update both site detials 
        await this.setSiteInfoUpdated(tenantId, newSite);
        await this.setSiteAPSUpdated(tenantId, newSite);

        await this.setSiteInfoUpdated(tenantId, oldSite);
        await this.setSiteAPSUpdated(tenantId, oldSite);
      }
    }
  }

  async checkAPExist(tenantId, documentId) {

    let data = (await this.firestore.collection("tenants")
      .doc(tenantId).collection('Aps').where('apMacAddress', '==', documentId.toUpperCase())
      .limit(1).get()).docs.map((doc) => doc.data());

    return data

  };

  async addAccessPoint(tenantId, accessPoint) {

      //DocumentId will be MAC ADRRESS
      var documentId = accessPoint.macAddress;
      documentId = documentId.toUpperCase();

      //Use merge option to merge the existing document if it exist
      var options = {
        merge: true
      };

     
      await this.firestore
            .collection("tenants") 
            .doc(tenantId)
            .collection("Aps").doc(documentId).set({ 
                //Store the MAC address in both the fields
                apMacAddress : this.getDBValue(accessPoint.macAddress),
                displayApMacAddress : this.getDBValue(accessPoint.macAddress),
                
                //Don't capitalize Asset Name
                apAssetName : this.getDBValue(accessPoint.assetName, false),

                //Store the MAC address in both the fields
                displayAPFriendlyName : this.getDBValue(accessPoint.friendlyName),
                apFriendlyName  : this.getDBValue(accessPoint.friendlyName),
               
                //Site Name
                siteName : this.getDBValue(accessPoint.siteName),
                displaySiteName: accessPoint.siteName,
                lastUpdatedAt: Date.now()
          }, options);
      
        await this.updateSiteLocation(tenantId, "", accessPoint.siteName);
      };
   
    async updateAccesspoint(tenantId, items) {

      //set only the fields to update
      var options = {
          mergeFields: [
            "displayAPFriendlyName",
            "apAssetName",
            "apFriendlyName"
            ]
        };
  
        for(var i =0 ; i< items.length; ++i){
        
          var item = items[i];
  
          //This needs to be changed
          var documentId = item.macAddress;
  
      
          var site = (await this.firestore
                .collection("tenants") 
                .doc(tenantId)
                .collection("Aps").doc(documentId).get()).data().siteName;
          
          await this.firestore
                .collection("tenants") 
                .doc(tenantId)
                .collection("Aps").doc(documentId).set({
                  //Don't capitalize Asset Name
                  //Site Name
                  displayAPFriendlyName : this.getDBValue(item.friendlyName),
                  apFriendlyName : this.getDBValue(item.friendlyName),

                  apAssetName: this.getDBValue(item.assetName),
                  lastUpdatedAt: Date.now()
              }, options);
          }
          //If we update accesspoint, Update site Info updated of the site 
          await this.setSiteInfoUpdated(tenantId, site);
          await this.setSiteAPSUpdated(tenantId, site);
        };
  
        
    async deleteAccessPoints(tenantId, items) {

      
      let batch = this.firestore.batch();

   
      for(var i =0; i< items.length; ++i) {
        
        var element = items[i];
        
        //Delete items one by one
        
        var doc = await this.firestore.collection("tenants")
          .doc(tenantId)
          .collection('Aps')
          .doc(element.apMacAddress).get();

          var site = doc.data().siteName;
      
          if(site != ""){
              //On deletion, update the Site APS
            this.setSiteAPSUpdated(tenantId, site);
          }
  
          batch.delete(doc.ref); 
       
      }

      await batch.commit();
    }
    
    
    async  updateSiteForAllAccessPoints(tenantId, query, siteName, lastMacAddress){
      let batch = this.firestore.batch();
       
        const BATCH_SIZE = 490;
    
        const snapshot = await query
          // .orderBy('reportedAt')
          .limit(BATCH_SIZE).get();
        const batchSize = snapshot.size;

        if(lastMacAddress != null){
          //There is a mac address to start with
          //This is called for next batch
          //So start the next batch from that
          query = query.startAfter(lastMacAddress);
        }

        
        if (batchSize === 0) {
          //All the records are updated
         
          return;
        } else {
          //Delete each record
          //Get the last Mac Address for the next query to start with
          //let snapshotData = snapshot.docs.map((doc) => doc.data());

          var lastMacAddress = null;
          snapshot.docs.forEach((doc) => {
            
            var oldSite = doc.data().siteName;
            
            //Update the siteName for each record
            batch.set(doc.ref, {
              ...doc.data(),
              lastUpdatedAt: Date.now(),
              siteName: this.getDBValue(siteName),
              displaySiteName: this.getDBValue(siteName)
            });

            //Set the site location
            this.updateSiteLocation(tenantId, oldSite, siteName);

            //Set the records address as last read mac access
            lastMacAddress = doc.data().apMacAddress;
          });
          await batch.commit(); 
          //Call this recursively to delete the next set
          await this.updateSiteForAllAccessPoints(tenantId, query, siteName, lastMacAddress);
        }
     
    }

    async updateSite(tenantId, items, site){
     // var options = new firebase.firestore.SetOptions();
      var options = {
        mergeFields: [
          "siteName"
          ]
      };

      for(var i =0 ; i< items.length; ++i){
        
        var item = items[i];

        //This needs to be changed
        var documentId = item.apMacAddress;

        var oldSite = (await this.firestore
              .collection("tenants") 
              .doc(tenantId)
              .collection("Aps").doc(documentId).get()).data().siteName;

        await this.firestore
              .collection("tenants") 
              .doc(tenantId)
              .collection("Aps").doc(documentId).set({
                //Don't capitalize Asset Name
                //Site Name
                siteName : this.getDBValue(site),
                displaySiteName:this.getDBValue(site),
                lastUpdatedAt: Date.now()
            }, options);
         
        //Set the site location
        this.updateSiteLocation(tenantId, oldSite, site);
        let modelnoSerialnoArr = [];
        await this.firestore
          .collection("tenants")
          .doc(tenantId)
          .collection("Devices")
          .where('apMacAddress', '==', documentId)
          .get()
          .then((datas) => {
            datas.forEach((doc) => {
              modelnoSerialnoArr.push(doc.id)
              doc.ref.update({siteName: this.getDBValue(site), displaySiteName: this.getDBValue(site)})
            })
        });

        for(var a=0;a<modelnoSerialnoArr.length;++a) {
          let ms = modelnoSerialnoArr[a];
          await this.firestore
                .collection("tenants")
                .doc(tenantId)
                .collection("Devices").doc(ms).collection("Monitor").doc("Assignment").update({
                  siteName: this.getDBValue(site),
                  displaySiteName: this.getDBValue(site)
                });
        }
      }
    }

    async  deleteAllAccessPoints(tenantId, query){
      let batch = this.firestore.batch();
  
      const BATCH_SIZE = 490;
  
      const snapshot = await query
        // .orderBy('reportedAt')
        .limit(BATCH_SIZE).get();
      const batchSize = snapshot.size;

      
      if (batchSize === 0) {
        //All the records are deleted
       
        return;
      } else {
        //Delete each record
        for(var i=0; i< snapshot.docs.length; ++i){
          var doc = snapshot.docs[i];
          
          var site = doc.data().siteName;

          if(site != ""){
            //On deletion, update the Site APS
           await this.setSiteAPSUpdated(tenantId, site);
         }
 
          batch.delete(doc.ref);
        }
        await batch.commit();
        //Call this recursively to delete the next set
        this.deleteAllAccessPoints(tenantId, query);
      }
   }
  }
